export default __webpack_public_path__ + "static/media/icon_webinars.d0e4a6d6.svg";